const { ALGOLIA_APPLICATION_ID, ALGOLIA_ENV, ALGOLIA_SEARCH_API, APP_ENV } = process.env
import {
  ALLOWED_ORIENTATION_VALUES,
  ALLOWED_PRICE_VALUES,
  PRICE_ATTRIBUTES_LIST,
  ALLOWED_SIZE_VALUES,
  CATEGORY_VALUES_NAMES,
  ALLOWED_CATEGORY_FACET_VALUES,
} from 'lib-ts/constructor/constants/hardcodedSaatchiFilters'
import { AllowedFacets, FacetsOrderAndIsOpen } from 'components/SA/SearchProvider/types'
export const applicationId: string = ALGOLIA_APPLICATION_ID || ''
export const searchApi: string = ALGOLIA_SEARCH_API || ''
const algoliaEnv: string = ALGOLIA_ENV || APP_ENV || 'production'
export const searchIndice: string = `${algoliaEnv}_all_artworks_artist_order`
export const DEFAULT_APP = '/public/profile/artistProfile'
export const DEFAULT_ALL_ARTWORKS_URL = '/account/artworks'

// Will add additional sort options in part 2.
export const sortOptions: Array<{
  value: string
  title: string
  indice: string
}> = [
  {
    value: 'default',
    title: 'Default',
    indice: searchIndice,
  },
]

export const USER_ARTWORKS_NEXT_APP_ROUTE = '/public/profile/artistProfile'

export const DEFAULT_ALL_ARTWORKS_SORT = {
  sortBy: 'newest',
  sortOrder: 'descending',
}

export const COMMON_FACET_NAMES = {
  CATEGORY: 'artwork_category',
  AVAILABILITY_STATUS: 'original_availability_status',
  SIZE: 'size_bin',
  PRICE: 'geo_prices',
  ORIENTATION: 'orientation',
}

export const FACET_NAMES: Record<string, string> = {
  ...COMMON_FACET_NAMES,
}

export const OTHER_FACETS = {
  WIDTH: 'width',
  HEIGHT: 'height',
}

const ALLOWED_ORIGINAL_AVAILABILITY_STATUS = [
  { label: 'Available', value: 'avail' },
  { label: 'Reserved', value: 'reserved' },
  { label: 'Sold', value: 'sold' },
  { label: 'Not Available', value: 'unavail' },
]

/* =================================================================================================================== */

// we will have to send the selectedFacets to the function that filter this (to filter the mediums and materials by the category selected)
// key is the facetName
export const ORIGINALS_ALLOWED_FACETS: AllowedFacets = {
  [FACET_NAMES.CATEGORY]: {
    allowedValues: ALLOWED_CATEGORY_FACET_VALUES,
    onlyNonEmptyResults: true,
    useHardcodedValues: false,
    useProviderValues: false,
    isOpen: false,
    title: 'Category',
    inputType: 'checkbox',
  },
  [FACET_NAMES.AVAILABILITY_STATUS]: {
    allowedValues: ALLOWED_ORIGINAL_AVAILABILITY_STATUS,
    onlyNonEmptyResults: true,
    useHardcodedValues: false,
    useProviderValues: false,
    isOpen: true,
    title: 'Original Availability',
    inputType: 'checkbox',
  },
  [FACET_NAMES.PRICE]: {
    allowedValues: ALLOWED_PRICE_VALUES,
    onlyNonEmptyResults: false,
    useHardcodedValues: true,
    useProviderValues: false,
    isOpen: true,
    title: 'Price',
    inputType: 'price',
    extraData: {
      priceOptions: PRICE_ATTRIBUTES_LIST,
    },
  },
  [FACET_NAMES.SIZE]: {
    allowedValues: ALLOWED_SIZE_VALUES,
    onlyNonEmptyResults: true,
    useHardcodedValues: false,
    useProviderValues: false,
    isOpen: true,
    title: 'Size',
    inputType: 'size',
  },
  [FACET_NAMES.ORIENTATION]: {
    allowedValues: ALLOWED_ORIENTATION_VALUES,
    onlyNonEmptyResults: true,
    useHardcodedValues: false,
    useProviderValues: false,
    isOpen: true,
    title: 'Orientation',
    inputType: 'checkbox',
  },
}

/* Order and is open logics */
// Paintings, Drawings, Printmaking, Digital, Mixed Media, Collage
const basicOrder = [
  FACET_NAMES.CATEGORY,
  FACET_NAMES.AVAILABILITY_STATUS,
  FACET_NAMES.SIZE,
  FACET_NAMES.PRICE,
  FACET_NAMES.ORIENTATION,
]
const basicIsOpen = [
  FACET_NAMES.CATEGORY,
  FACET_NAMES.AVAILABILITY_STATUS,
  FACET_NAMES.SIZE,
  FACET_NAMES.PRICE,
  FACET_NAMES.ORIENTATION,
]

// change this to check if it is expanded or collapsed too
export const ORIGINALS_FACETS_ORDER_AND_IS_OPEN: FacetsOrderAndIsOpen = {
  [CATEGORY_VALUES_NAMES.ALL]: {
    order: basicOrder,
    isOpen: basicIsOpen,
  },
  [CATEGORY_VALUES_NAMES.PAINTINGS]: {
    order: basicOrder,
    isOpen: basicIsOpen,
  },
  [CATEGORY_VALUES_NAMES.PHOTOGRAPHY]: {
    order: basicOrder,
    isOpen: basicIsOpen,
  },
  [CATEGORY_VALUES_NAMES.DRAWINGS]: {
    order: basicOrder,
    isOpen: basicIsOpen,
  },
  [CATEGORY_VALUES_NAMES.PRINTMAKING]: {
    order: basicOrder,
    isOpen: basicIsOpen,
  },
  [CATEGORY_VALUES_NAMES.DIGITAL]: {
    order: basicOrder,
    isOpen: basicIsOpen,
  },
  [CATEGORY_VALUES_NAMES.MIXED_MEDIA]: {
    order: basicOrder,
    isOpen: basicIsOpen,
  },
  [CATEGORY_VALUES_NAMES.COLLAGE]: {
    order: basicOrder,
    isOpen: basicIsOpen,
  },
  [CATEGORY_VALUES_NAMES.SCULPTURE]: {
    order: basicOrder,
    isOpen: basicIsOpen,
  },
  [CATEGORY_VALUES_NAMES.INSTALLATION]: {
    order: basicOrder,
    isOpen: basicIsOpen,
  },
}
